import { useEffect, useState } from 'react'

declare global {
  interface Window {
    DocuSign: any
  }
}

interface DocusignInstance {
  signing: (config: any) => any
}

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string, event: any) => void
    }
  }
}

const DocuSign = () => {
  const [docusignInstance, setDocusignInstance] =
    useState<DocusignInstance | null>(null)

  const urlParams = new URLSearchParams(window.location.search)
  const clientId = urlParams.get('clientId')
  const signingUrl = urlParams.get('signingUrl')

  useEffect(() => {
    if (clientId) {
      const loadScripts = async () => {
        const docusignScript = document.createElement('script')
        docusignScript.src = 'https://js-d.docusign.com/bundle.js'
        docusignScript.async = true
        document.body.appendChild(docusignScript)

        const jqueryScript = document.createElement('script')
        jqueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js'
        jqueryScript.async = true
        document.body.appendChild(jqueryScript)

        docusignScript.onload = async () => {
          try {
            const docusign = await window.DocuSign.loadDocuSign(clientId)
            setDocusignInstance(docusign)
          } catch (error) {
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                'Erro ao carregar DocuSign:',
                error
              )
            }
          }
        }
      }
      loadScripts()
    }
  }, [clientId])

  useEffect(() => {
    if (docusignInstance && signingUrl) {
      const signingConfiguration = {
        url: signingUrl,
        displayFormat: 'focused',
        style: {
          branding: {
            primaryButton: {
              backgroundColor: '#FFC600',
              color: 'black',
            },
          },
          signingNavigationButton: {
            finishText: 'Assinar',
            position: 'bottom-center',
          },
        },
      }

      const signing = docusignInstance.signing(signingConfiguration)

      signing.on('ready', () => console.log('UI is rendered'))
      signing.on('sessionEnd', (event: any) => {
        // Verifica se ReactNativeWebView está disponível antes de chamar postMessage
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage('sessionEnd', event)
        }
      })

      signing.mount('#docusignContainer')
    }
  }, [docusignInstance, signingUrl])

  return (
    <div>
      <div id="main" style={{ display: docusignInstance ? 'none' : 'block' }}>
        {/* Conteúdo principal aqui */}
      </div>
      <div
        id="signing-ceremony"
        style={{ display: docusignInstance ? 'block' : 'none' }}
      >
        <div
          className="docusign-agreement-container"
          id="docusignContainer"
          style={{ height: '100vh', width: '100vw' }}
        />
      </div>
    </div>
  )
}

export default DocuSign
